import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { FAQItem } from "../../component/FAQItem/FAQItem";
import { Accordion } from "../../component/Accordion/Accordion";
import { darkTextureWrapper, colorSettingDetection, renderHeaderConditionally } from "../../utils/functions";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { layoutHeaderClasses, layoutHeaderBigClasses, layoutSubheaderClasses, layoutEyebrowClasses } from "@/components/tailwindHelpers";
export interface LayoutFAQsProps {
  eyebrow?: string;
  header?: string;
  headerElement?: "h1" | "h2";
  subheader?: string;
  description?: string | React.ReactNode;
  faqType?: "t2-collapsed" | "t2-expanded";
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  faqItems?: FAQItem[];
  buttons?: TerraLink[];
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  isEmbedded?: boolean;
}
export const LayoutFAQs = t0 => {
  const $ = _c(45);
  const {
    eyebrow,
    header,
    headerElement: t1,
    subheader,
    description,
    faqType: t2,
    presetTheme: t3,
    faqItems,
    buttons,
    isHeaderBig,
    isWrapped,
    isEmbedded
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const faqType = t2 === undefined ? "t2-collapsed" : t2;
  const presetTheme = t3 === undefined ? "t2-theme-one" : t3;
  const wrapperClasses = isEmbedded ? `${isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px]" : ""}` : "w-full px-5 lg:px-20 m-auto max-w-[1440px]";
  let t4;
  if ($[0] !== isEmbedded || $[1] !== presetTheme) {
    t4 = isEmbedded ? "" : colorSettingDetection(presetTheme || "");
    $[0] = isEmbedded;
    $[1] = presetTheme;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const colorSetting = t4;
  const mainClasses = isEmbedded ? `t2-layout-faq [&_.t2-spbutton__wrap_.t2-spbutton__field]:my-2.5 t2-layout-faq--t-${faqType}` : `t2-layout-faq py-[100px] [&_.t2-spbutton__wrap_.t2-spbutton__field]:my-2.5 t2-layout-faq--t-${faqType} ${presetTheme || ""} ${colorSetting}`;
  const headerClasses = `t2-layout-faq__header ${isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses}`;
  const t5 = header || "";
  let t6;
  if ($[3] !== headerClasses || $[4] !== headerElement || $[5] !== t5) {
    t6 = renderHeaderConditionally(headerClasses, t5, headerElement);
    $[3] = headerClasses;
    $[4] = headerElement;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const finalHeader = t6;
  let accordionStructure;
  if ($[7] !== faqItems || $[8] !== faqType) {
    accordionStructure = [];
    if (faqItems && faqType === "t2-collapsed") {
      for (const item of faqItems) {
        const accordionItem = {
          headline: item.headline || "",
          description: item.description,
          ctaLink: item.ctaLink
        };
        accordionStructure.push(accordionItem);
      }
    }
    $[7] = faqItems;
    $[8] = faqType;
    $[9] = accordionStructure;
  } else {
    accordionStructure = $[9];
  }
  let t7;
  if ($[10] !== isEmbedded || $[11] !== presetTheme) {
    t7 = isEmbedded ? undefined : darkTextureWrapper(presetTheme || "");
    $[10] = isEmbedded;
    $[11] = presetTheme;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const componentStyles = t7;
  let t8;
  if ($[13] !== description || $[14] !== eyebrow || $[15] !== finalHeader || $[16] !== header || $[17] !== isEmbedded || $[18] !== subheader) {
    t8 = (eyebrow || header || subheader || description) && <div className={`t2-layout-faq__primary-content${isEmbedded ? "" : " pb-12"}`}><div className="t2-header-area">{eyebrow && <div className={`t2-layout-faq__eyebrow ${layoutEyebrowClasses}`}>{eyebrow}</div>}{finalHeader}{subheader && <div className={layoutSubheaderClasses}>{subheader}</div>}{description && <CommonDescription description={description} className="t2-layout-faq__description t2-layout__description" />}</div></div>;
    $[13] = description;
    $[14] = eyebrow;
    $[15] = finalHeader;
    $[16] = header;
    $[17] = isEmbedded;
    $[18] = subheader;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = `t2-layout-faq__items ${faqType !== "t2-collapsed" ? "flex gap-8 [&_.t2-faq-item]:max-w-[400px]" : ""}`;
  let t10;
  if ($[20] !== accordionStructure || $[21] !== faqType) {
    t10 = faqType === "t2-collapsed" && accordionStructure && accordionStructure.map(_temp);
    $[20] = accordionStructure;
    $[21] = faqType;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== faqItems || $[24] !== faqType) {
    t11 = faqType !== "t2-collapsed" && faqItems && faqItems.map(_temp2);
    $[23] = faqItems;
    $[24] = faqType;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t9) {
    t12 = <div className={t9}>{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== buttons) {
    t13 = buttons && buttons.map(_temp3);
    $[30] = buttons;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13) {
    t14 = <div className="t2-layout-faq__cta flex gap-8 flex-col sm:flex-row justify-center pt-[50px] max-sm:[&_.t2-button]:w-full max-sm:[&_.t2-button]:py-4 max-sm:[&_.t2-button]:px-9">{t13}</div>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t8) {
    t15 = <div className="t2-layout-faq__content t2-layout__content">{t8}{t12}{t14}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t8;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15 || $[39] !== wrapperClasses) {
    t16 = <div className={wrapperClasses}>{t15}</div>;
    $[38] = t15;
    $[39] = wrapperClasses;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== componentStyles || $[42] !== mainClasses || $[43] !== t16) {
    t17 = <div className={mainClasses} style={componentStyles} data-testid="layout-faq">{t16}</div>;
    $[41] = componentStyles;
    $[42] = mainClasses;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  return t17;
};
function _temp(item_0, index) {
  return <div key={`accordion-${index}`} data-testid="faq-item"><Accordion {...item_0} /></div>;
}
function _temp2(item_1, index_0) {
  return <div key={`faq-${index_0}`} data-testid="faq-item"><FAQItem {...item_1} /></div>;
}
function _temp3(btn, index_1) {
  return <TerraLink key={`button-${index_1}`} {...btn} />;
}